import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { ContainersService } from '@services/containers/containers.service';

@Component({
  selector: 'app-opendialog-new-container',
  templateUrl: './opendialog-new-container.component.html',
  styleUrls: ['./opendialog-new-container.component.scss']
})
export class OpendialogNewContainerComponent implements OnInit {

  startContainerform: FormGroup;
  inProgress = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private containersService: ContainersService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    this.inProgress = true;
    const confirm = document.getElementsByClassName('confirm') as HTMLCollectionOf<HTMLElement>;


    const newContainer = {
      startedOn: this.f.startedOn.value.toISOString(),
      weight: this.f.weight.value
    };

    this.containersService.addNewContainer(newContainer).subscribe(() => {
      this.containersService.getContainers(new PaginationRequest());
      this.dialog.closeAll();
      this.inProgress = false;
    });

  }

  get f() {
    return this.startContainerform.controls;
  }

  private initForm(): void {
    const date = new Date();
    this.startContainerform = this.formBuilder.group({
      startedOn: [date],
      weight: [0, Validators.required]
    });
  }

}
